(function () {
  'use strict';
  var locale = (document.documentElement.lang || 'en').toLowerCase();
  if (!/^(en|pt)(-|$)/.test(locale)) return;
  var currency = document.querySelector('[data-r36s-bundle-currency]');
  currency = currency && currency.dataset.r36sBundleCurrency;
  if (!currency) return;
  var formatter = new Intl.NumberFormat(locale, {style: 'currency', currency: currency});
  var label = locale.startsWith('pt') ? 'Economize ' : 'Save ';
  function amount(text) {
    var raw = (text || '').replace(/[^\d.,-]/g, '');
    if (!raw) return null;
    var match = raw.match(/[.,](\d{2})$/);
    var whole = match ? raw.slice(0, -3) : raw;
    var cents = Number(whole.replace(/[.,]/g, '')) * 100 + (match ? Number(match[1]) : 0);
    return Number.isFinite(cents) ? cents : null;
  }
  function update() {
    document.querySelectorAll('[id="moonbundle-option"]').forEach(function (offer) {
      var badge = offer.querySelector('.moonbundle-label-inside');
      var current = offer.querySelector('.moonbundle-option-price > .moonbundle-option-single-price');
      var previous = offer.querySelector('.moonbundle-option-price > .moonbundle-option-old-price');
      if (!badge) return;
      var price = amount(current && current.textContent);
      var reference = amount(previous && previous.textContent);
      if (price === null || reference === null || reference <= price) {
        badge.hidden = true;
        return;
      }
      var text = label + formatter.format((reference - price) / 100);
      if (badge.textContent !== text) badge.textContent = text;
      badge.hidden = false;
      badge.setAttribute('data-r36s-saving', 'calculated');
    });
    document.querySelectorAll('.moonbundle-title').forEach(function (heading) {
      if (/winter|inverno|hiver/i.test(heading.textContent)) {
        heading.textContent = locale.startsWith('pt') ? 'Escolha seu pacote R36S' : 'Choose your R36S pack';
      }
    });
  }
  var pending = false;
  var observer = new MutationObserver(function (records) {
    if (pending || !records.some(function (r) {
      var el = r.target.nodeType === 1 ? r.target : r.target.parentElement;
      return el && (el.closest('.moonbundle-box') || Array.from(r.addedNodes).some(function (n) { return n.nodeType === 1 && (n.matches('.moonbundle-box') || n.querySelector('.moonbundle-box')); }));
    })) return;
    pending = true;
    setTimeout(function () { pending = false; update(); }, 80);
  });
  observer.observe(document.body, {childList: true, characterData: true, subtree: true});
  update();
})();
